import { render, staticRenderFns } from "./ProductContentExams.vue?vue&type=template&id=6473588d&scoped=true&"
import script from "./ProductContentExams.vue?vue&type=script&lang=js&"
export * from "./ProductContentExams.vue?vue&type=script&lang=js&"
import style0 from "./ProductContentExams.vue?vue&type=style&index=0&id=6473588d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6473588d",
  null
  
)

export default component.exports